import checkout from "./form";

const {
  formField: {
    id,
    name,
    email,
    website,
    description,
    phoneNumber,
    shortNumber,
    logoUrl,
    enProfileUrl,
    arProfileUrl,
  },
} = checkout;

const initialValues = {
  [id.name]: 0,
  [name.name]: "",
  [email.name]: "",
  [website.name]: "",
  [description.name]: "",
  [phoneNumber.name]: "",
  [shortNumber.name]: "",
  [logoUrl.name]: null,
  [enProfileUrl.name]: null,
  [arProfileUrl.name]: null,
};

export default initialValues;
